<div class="bar">
  <div class="progress" [ngStyle]="{ width: width }"></div>
  @if (marker) {
    <div class="marker" [ngStyle]="{ left: markerPosition }"><div class="fill"></div></div>
  }
</div>
